import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { colors, screenPadding, spacing } from '../../theme';
import Icon from '../ui/Icon';
import Text from '../ui/Text';

type Props = {
  title: string;
  /** Optional second line explaining what the section is. */
  subtitle?: string;
  actionLabel?: string;
  onPressAction?: () => void;
};

/** Section title with an optional "see all" on the right. */
function SectionHeader({ title, subtitle, actionLabel, onPressAction }: Props) {
  return (
    <View style={styles.row}>
      <View style={styles.titles}>
        <Text variant="title">{title}</Text>
        {subtitle ? (
          <Text variant="caption" style={styles.subtitle}>
            {subtitle}
          </Text>
        ) : null}
      </View>

      {actionLabel ? (
        <Pressable
          accessibilityRole="button"
          accessibilityLabel={`${actionLabel}, ${title}`}
          onPress={onPressAction}
          hitSlop={10}
          style={({ pressed }) => [styles.action, pressed ? styles.pressed : null]}
        >
          <Text variant="labelSm" color={colors.primary}>
            {actionLabel}
          </Text>
          <Icon name="chevronRight" size={15} color={colors.primary} strokeWidth={2} />
        </Pressable>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.md,
    paddingHorizontal: screenPadding,
    marginBottom: spacing.sm,
  },
  titles: {
    flex: 1,
  },
  subtitle: {
    marginTop: 2,
  },
  action: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
  },
  pressed: {
    opacity: 0.6,
  },
});

/* Memoised - one per section, re-rendered by any state change on Home. */
export default React.memo(SectionHeader);
